import React from 'react';

import InforPreview from '../../../../../../../../../common/InforPreview';
import SimulationDoneFrozen from '../../../../../../../../../common/SimulationDoneFrozen';
import DialogActionsWrapper from '../DialogActionWrapper';
const ShoppingCartFactoringAccepted = (props: any) => {
  const { setOpenShoppingCart, selectedRequest, setUp, selectedId } = props;

  const infoDiv = (
    <InforPreview
      requestType="factoring"
      type="Recieved"
      status="Rechazada"
      selectedRequest={selectedRequest}
    />
  );

  return (
    <div>
      <div>
        <SimulationDoneFrozen
          selectedRequest={selectedRequest}
          infoDiv={infoDiv}
        />
        <DialogActionsWrapper
          type="factoring"
          onClose={() => setOpenShoppingCart(false)}
          selectedRequest={selectedRequest}
          setUp={setUp}
          selectedId={selectedId}
        />
      </div>
    </div>
  );
};

export default ShoppingCartFactoringAccepted;
